import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import { ConstituentListItem } from './constituent-list-item/constituent-list-item';
import styles from './constituents-list.css';
export function ConstituentsList(props) {
    const { constituents, className } = props;
    return (_jsx("div", { className: classNames(styles.wrapper, className), ...assignTestId('constituents-list'), children: constituents.map(constituent => (_jsx(ConstituentListItem, { constituentId: constituent }, constituent))) }));
}
